export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-photo-997d025648a8456ddf04c79c3bcd692c.svg";